// static data
const graphicBurstsTop = [
  {
    titleEnglish: 'Attract, retain and thank your volunteers',
    titleWelsh: 'Denu, cadw a rhoi diolch i wirfoddolwyr',
    image: 'graphicBurst8',
  },
  {
    titleEnglish: 'Increase engagement in services',
    titleWelsh: 'Cynyddu ymgysylltiad mewn gwasanaethau',
    image: 'graphicBurst9',
  },
  {
    titleEnglish: 'Maximise community participation',
    titleWelsh: 'Gwneud y mwyaf o gyfranogiad cymunedol',
    image: 'graphicBurst10',
  },
];

const graphicBurstsBottom = [
  {
    titleEnglish: "Attract new people who haven't visited before",
    titleWelsh: 'Denu pobl newydd nad ydyn nhw wedi ymweld o’r blaen',
    image: 'graphicBurst11',
  },
  {
    titleEnglish: 'Bring in new potential customers',
    titleWelsh: 'Denu darpar gwsmeriaid newydd',
    image: 'graphicBurst12',
  },
  {
    titleEnglish: 'Build your reputation',
    titleWelsh: 'Adeiladu eich enw da',
    image: 'graphicBurst13',
  },
  {
    titleEnglish: 'Stand out from competitors',
    titleWelsh: 'Sefyll allan oddi wrth eich cystadleuwyr',
    image: 'graphicBurst14',
  },
  {
    titleEnglish: 'Achieve Corporate Social Responsibility goals',
    titleWelsh: 'Cyflawni nodau Cyfrifoldeb Cymdeithasol Corfforaethol',
    image: 'graphicBurst16',
  },
  {
    titleEnglish: 'Benefit from our marketing',
    titleWelsh: 'Elwa o’n marchnata',
    image: 'graphicBurst1',
  },
];

export { graphicBurstsBottom, graphicBurstsTop };
